import { coveragesListTotal, coveragesListPremium, coveragesListStandar } from '../../data/coverages';
import * as TYPE from '../types/coverage';

const initialState = {
  coveragesList: [...coveragesListStandar],
  currentPlan: 'STANDAR',
  userFlowType: 'input',
  currentProduct: '1103',
  errorCode: -1
};

const coverages = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.SET_INIT_COVERAGE_LIST:
      const coveragesPlan = {
        TOTAL: [...coveragesListTotal],
        PREMIUM: [...coveragesListPremium],
        STANDAR: [...coveragesListStandar],
      }
      return {
        ...state,
        coveragesList: coveragesPlan[action.payload]
      };
    case TYPE.SET_COVERAGE_LIST:
      return {
        ...state,
        coveragesList: [...action.payload],
      };
    case TYPE.SET_COVERAGE_PLAN_TYPE:
      return {
        ...state,
        currentPlan: action.payload,
      };
    case TYPE.SET_PRODUCT:
      return {
        ...state,
        currentProduct: action.payload,
      };
    case TYPE.SET_USER_FLOW_TYPE:
      return {
        ...state,
        userFlowType: action.payload,
      };
    case TYPE.SET_ERROR_CODE:
      return {
        ...state,
        errorCode: action.payload,
      };
    default:
      return state;
  }
};

export default coverages;
